import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pandas",
  "use": "pandas-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"pandas\"><path d=\"M6.81 1.946h1.748v3.63H6.81zm0 7.458h1.748v3.631H6.81zm0-2.768h1.748V8.35H6.81zM4 4.931H5.75V17H4zM9.56 12.4h1.75v3.63H9.56zm0-7.465h1.75v3.63H9.56zm0 4.691h1.75v1.713H9.56zM12.311 1h1.749v12.07H12.31z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol